import { calculateDimensions } from '../../constants/pageSizes';

// Default to US Trade size if not specified
export const SPREAD_DIMENSIONS = {
  width: 600,
  height: 800,
  safeZone: 40
};

// Gutter padding configuration for better book readability
export const GUTTER_CONFIG = {
  // Padding on each side of the gutter (in pixels)
  padding: 60,
  // Visual indicator width
  indicatorWidth: 2,
  // Color for gutter area
  backgroundColor: 'rgba(229, 231, 235, 0.3)', // Light gray with transparency
  // Border color for gutter guides
  borderColor: '#D1D5DB'
};

export function getSpreadDimensions(pageSize) {
  const dimensions = calculateDimensions(pageSize);
  
  // Check if this is a landscape orientation
  const isLandscape = dimensions.orientation === 'landscape';
  
  // For landscape orientation, we need to swap width and height
  // to ensure the canvas reflects the correct aspect ratio
  if (isLandscape) {
    return {
      width: dimensions.width,
      height: dimensions.height,
      safeZone: 40,
      orientation: 'landscape',
      gutterPadding: 0 // No gutter for landscape/single page
    };
  }
  
  return {
    ...dimensions,
    safeZone: 40,
    gutterPadding: GUTTER_CONFIG.padding // Add gutter padding for spreads
  };
}

export const ELEMENT_DEFAULTS = {
  text: {
    size: { width: 200, height: 60 },
    content: 'Click to edit text',
    style: {
      fontFamily: 'Arial',
      fontSize: '16px',
      color: '#000000',
      textAlign: 'left',
      fontWeight: 'normal',
      fontStyle: 'normal',
      textDecoration: 'none'
    }
  },
  image: {
    size: { width: 300, height: 300 },
    style: {
      objectFit: 'contain'
    }
  },
  shape: {
    size: { width: 100, height: 100 },
    shape: 'rectangle',
    style: {
      fill: '#000000',
      opacity: 1,
      borderRadius: '0px'
    }
  }
};